/* ExceptionalFire — Lexington Custom Mantel Builder
   3 steps: Style -> Width -> Review. Custom pricing via Draft Order Worker.
   Pricing rules:
     - exact standard width  -> standard price
     - custom width in range (< maxStd) -> price of next size UP + $350
     - combo (> maxStd, to maxStd+48, cap 120) -> maxStdPrice * (1 + 0.65*numExtensions)
       (each 24" extension = 65% of largest standard price; decorative bracket set included)
*/
(function () {
  'use strict';
  var root = document.getElementById('lxc-root');
  if (!root) return;
  var DATA;
  try { DATA = JSON.parse(document.getElementById('ef-lxc-data').textContent); } catch (e) { return; }
  var SWATCH = {}; try { SWATCH = JSON.parse(document.getElementById('ef-lxc-swatches').textContent); } catch (e) {}
  var FG = {}; try { FG = JSON.parse(document.getElementById('ef-lxc-fg').textContent); } catch (e) {}
  var GLBMAP = {}; try { GLBMAP = JSON.parse(document.getElementById('ef-lxc-glb').textContent); } catch (e) {}
  var USDZMAP = {}; try { USDZMAP = JSON.parse(document.getElementById('ef-lxc-usdz').textContent); } catch (e) {}
  var VARIANTS = {}; try { VARIANTS = JSON.parse(document.getElementById('ef-lxc-variants').textContent); } catch (e) {}
  var PTITLES = {}; try { PTITLES = JSON.parse(document.getElementById('ef-lxc-ptitles').textContent); } catch (e) {}
  var SURCHARGE_VARIANT = 42430856986706; // $1 "EF Mantel Made-to-Order Fee" — qty = $ of surcharge
  var WORKER = window.EF_DRAFT_ORDER_WORKER_URL || 'https://ef-draft-order.danielzajacus.workers.dev';
  var CUSTOM_FEE = 350;
  var EXT_FACTOR = 0.65;   // each extension = 65% of largest standard price
  var EXT_INCHES = 24;
  var MAX_COMBO_EXT = 2;
  var CUSTOM_FINISH_FEE = 300;       // custom color match
  var CF_LABEL = 'Custom Color Match';
  var COMBO_DIAGRAM = 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/lexington-combo-mantel-diagram-v2-2026-08-07.png?v=1786126733';

  function priced() {
    var c = calc(state.model, state.width);
    var ff = (state.finish === CF_LABEL) ? CUSTOM_FINISH_FEE : 0;
    return { c: c, ff: ff, total: c.price + ff };
  }
  function toggleColorRef(show) {
    var wrap = root.querySelector('#lxc-colorref-wrap');
    if (wrap) wrap.style.display = show ? 'block' : 'none';
  }

  var state = { model: null, width: null, finish: null, qty: 1 };
  var money = function (n) { return '$' + Math.round(n).toLocaleString('en-US'); };
  var fmtW = function (w) { return (w % 1 === 0 ? w : w.toFixed(1)) + '"'; };
  function parseInches(s) {
    if (!s) return 0; s = String(s).replace(/[″"]/g, '').trim();
    var map = { '½': .5, '¼': .25, '¾': .75, '⅜': .375, '⅝': .625, '⅛': .125, '⅞': .875, '⅓': .333, '⅔': .667 };
    var m = s.match(/^(\d+)?\s*([½¼¾⅜⅝⅛⅞⅓⅔])$/);
    if (m) return (parseInt(m[1] || '0', 10)) + (map[m[2]] || 0);
    var f = parseFloat(s); return isNaN(f) ? 0 : f;
  }
  // Live scale visualizer — mantel beam drawn to scale beside a 6ft person
  function updateScale(m, w) {
    var el = root.querySelector('#lxc-scale'); if (!el) return;
    var PXI = 1.7, H = 72 * PXI, floorY = H + 8;
    var bw = w * PXI, bh = Math.max(4, parseInches(m.height)) * PXI;
    var humanW = 26 * PXI, gap = 18, beamX = humanW + gap, beamY = floorY - 0.46 * H - bh;
    var vbW = Math.max(beamX + bw + 10, 260), vbH = floorY + 24, hx = humanW / 2;
    var s = '<svg viewBox="0 0 ' + vbW + ' ' + vbH + '" width="100%" preserveAspectRatio="xMinYMax meet" role="img" aria-label="Scale preview">';
    s += '<line x1="0" y1="' + floorY + '" x2="' + vbW + '" y2="' + floorY + '" stroke="#DED6CB" stroke-width="1.5"/>';
    s += '<g fill="#d8cfc1"><circle cx="' + hx + '" cy="' + (floorY - H + 9 * PXI) + '" r="' + (5 * PXI) + '"/>';
    s += '<rect x="' + (hx - 6 * PXI) + '" y="' + (floorY - H + 15 * PXI) + '" width="' + (12 * PXI) + '" height="' + (H - 15 * PXI) + '" rx="' + (5 * PXI) + '"/></g>';
    s += '<text x="' + hx + '" y="' + (floorY + 16) + '" text-anchor="middle" font-size="10" fill="#9b9183">6 ft</text>';
    s += '<rect x="' + beamX + '" y="' + beamY + '" width="' + bw + '" height="' + bh + '" rx="3" fill="#6b4f34"/>';
    s += '<rect x="' + beamX + '" y="' + beamY + '" width="' + bw + '" height="' + Math.min(bh, 4) + '" fill="#8A6A43"/>';
    s += '<text x="' + (beamX + bw / 2) + '" y="' + (beamY - 7) + '" text-anchor="middle" font-size="12" fill="#1E1E1B" font-weight="700">' + fmtW(w) + '</text>';
    s += '</svg>';
    el.innerHTML = s;
    var cap = root.querySelector('#lxc-sizeref'); if (cap) cap.textContent = '📏 Shown to scale next to a 6 ft adult · ' + m.depth + ' deep × ' + m.height + ' tall';
  }
  // gallery for a model+finish (uses finish-specific white-bg set when available)
  function galleryFor(m, finish) {
    if (m.finishGalleries && finish && m.finishGalleries[finish]) return m.finishGalleries[finish];
    return (m.gallery && m.gallery.length) ? m.gallery : [m.img];
  }
  var galImgs = [], galIdx = 0;
  function setGal(i) {
    if (!galImgs.length) return;
    galIdx = (i + galImgs.length) % galImgs.length;
    var mainImg = root.querySelector('#lxc-m-img'); if (mainImg) mainImg.src = galImgs[galIdx];
    root.querySelectorAll('#lxc-thumbs .lxc-thumb').forEach(function (x, k) { x.classList.toggle('is-active', k === galIdx); });
  }
  function renderGallery(imgs) {
    if (!imgs || !imgs.length) return;
    galImgs = imgs.slice(); galIdx = 0;
    var mainImg = root.querySelector('#lxc-m-img'); mainImg.src = imgs[0];
    var th = root.querySelector('#lxc-thumbs'); th.innerHTML = '';
    imgs.forEach(function (src, i) {
      var t = document.createElement('button'); t.type = 'button'; t.className = 'lxc-thumb' + (i === 0 ? ' is-active' : '');
      t.innerHTML = '<img src="' + src + '" alt="" loading="lazy">';
      t.addEventListener('click', function () { setGal(i); });
      th.appendChild(t);
    });
  }
  // mobile finger-swipe on the main gallery image
  (function () {
    var mainImg = root.querySelector('#lxc-m-img'); if (!mainImg) return;
    var x0 = null, y0 = null;
    mainImg.addEventListener('touchstart', function (e) { var t = e.changedTouches[0]; x0 = t.clientX; y0 = t.clientY; }, { passive: true });
    mainImg.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) setGal(galIdx + (dx < 0 ? 1 : -1));
      x0 = y0 = null;
    }, { passive: true });
  })();
  function flashGalHint(finish) {
    var h = root.querySelector('#lxc-galhint'); if (!h) return;
    var hasG = state.model && state.model.finishGalleries && state.model.finishGalleries[finish];
    h.innerHTML = '📷 ' + (hasG ? ('Gallery updated for <b>' + finish + '</b> — swipe the photos above.') : 'Swipe the photos above to view every angle.');
    h.classList.remove('flash'); void h.offsetWidth; h.classList.add('flash');
  }
  // 3D model — resolved per STYLE (and per finish where that finish has its own model).
  // Resolution order, so the viewer stays "alive" as you move between styles:
  //   1. this style + this finish  -> exact model, no disclaimer
  //   2. this style + any finish   -> that model + a discreet "shown in X finish" note
  //   3. no model for this style   -> viewer hidden (never borrow another style's shape)
  function currentGlb(m, finish) {
    var map = m.glbFinishes; if (!map) return null;
    if (finish && map[finish]) return { url: map[finish], finish: finish, exact: true };
    var order = (m.finishes || []).concat(Object.keys(map));
    for (var i = 0; i < order.length; i++) {
      if (map[order[i]]) return { url: map[order[i]], finish: order[i], exact: false };
    }
    return null;
  }
  function usdzFor(m, finish) {
    var map = USDZMAP[m.name]; return (map && finish && map[finish]) ? map[finish] : '';
  }
  function showVisual(m, finish, width) {
    var mv = root.querySelector('#lxc-mv'), cap = root.querySelector('#lxc-scalecap'),
        note = root.querySelector('#lxc-mvnote'), pill = root.querySelector('#lxc-arpill');
    var g = currentGlb(m, finish);
    if (g && mv) {
      if (mv.getAttribute('src') !== g.url) {
        // subtle loader + fade while the new GLB streams in
        mv.classList.add('is-loading');
        mv.setAttribute('src', g.url);
        mv.setAttribute('poster', m.img);
        var iosSrc = usdzFor(m, g.finish);
        if (iosSrc) { mv.setAttribute('ios-src', iosSrc); } else { mv.removeAttribute('ios-src'); }
        var done = function () { mv.classList.remove('is-loading'); mv.removeEventListener('load', done); };
        mv.addEventListener('load', done);
        setTimeout(done, 6000); // safety net if the load event never fires
      }
      mv.style.display = '';
      if (note) {
        if (g.exact) { note.hidden = true; note.textContent = ''; }
        else { note.hidden = false; note.textContent = '3D preview shown in ' + g.finish + ' finish'; }
      }
      if (cap) cap.innerHTML = '✋ Drag to rotate · pinch to zoom · <b>tap “View in your room” for AR</b>';
      if (pill) {
        pill.hidden = false;
        pill.setAttribute('data-ar-glb', g.url);
        pill.setAttribute('data-ar-usdz', usdzFor(m, g.finish) || '');
      }
    } else {
      if (mv) { mv.style.display = 'none'; mv.removeAttribute('src'); mv.classList.remove('is-loading'); }
      if (note) { note.hidden = true; note.textContent = ''; }
      if (pill) pill.hidden = true;
      if (cap) cap.textContent = '';
    }
  }

  // ---- pricing ----
  function calc(model, w) {
    var sizes = model.sizes.slice().sort(function (a, b) { return a.w - b.w; });
    var minStd = sizes[0].w, maxStd = sizes[sizes.length - 1].w, maxPrice = sizes[sizes.length - 1].price;
    var floor = model.minWidth || minStd;
    var capMax = Math.min(120, maxStd + EXT_INCHES * MAX_COMBO_EXT);
    w = Math.max(floor, Math.min(w, capMax));
    var exact = sizes.filter(function (s) { return s.w === w; })[0];
    if (exact) return { width: w, price: exact.price, pieces: 1, combo: false, custom: false, fee: 0, ext: 0, base: exact.price, maxStd: maxStd, capMax: capMax, minStd: minStd };
    if (w <= maxStd) {
      var up = sizes.filter(function (s) { return s.w >= w; })[0] || sizes[sizes.length - 1];
      return { width: w, price: up.price + CUSTOM_FEE, pieces: 1, combo: false, custom: true, fee: CUSTOM_FEE, ext: 0, base: up.price, baseW: up.w, maxStd: maxStd, capMax: capMax, minStd: minStd };
    }
    var numExt = Math.min(MAX_COMBO_EXT, Math.ceil((w - maxStd) / EXT_INCHES));
    return { width: w, price: Math.round(maxPrice * (1 + EXT_FACTOR * numExt)), pieces: 1 + numExt, combo: true, custom: true, fee: 0, ext: numExt, brackets: Math.max(2, numExt), base: maxPrice, maxStd: maxStd, capMax: capMax, minStd: minStd };
  }

  // ---- step nav ----
  function go(n) {
    root.querySelectorAll('.lxc__panel').forEach(function (p) { p.classList.toggle('is-active', +p.dataset.step === n); });
    root.querySelectorAll('.lxc__steps span').forEach(function (s) {
      var i = +s.dataset.step;
      s.classList.toggle('is-active', i === n);
      s.classList.toggle('is-done', i < n);
    });
    window.scrollTo({ top: root.offsetTop - 20, behavior: 'smooth' });
    if (n === 2 && window.LXCBeam) setTimeout(function () { window.LXCBeam.resize(); }, 90);
    /* 2026-08-12: krok 2 wchodzi do historii przeglądarki — wstecz cofa do stylów, nie do poprzedniej strony */
    if (n === 2 && !lxcHist) { try { history.pushState({ lxcStep: 2 }, ''); lxcHist = true; } catch (e) {} }
  }
  var lxcHist = false;
  function lxcCurrentStep() {
    var p = root.querySelector('.lxc__panel.is-active');
    return p ? +p.dataset.step : 1;
  }
  function backToStyles() {
    if (lxcHist) { try { history.back(); return; } catch (e) {} }
    go(1);
  }
  window.addEventListener('popstate', function () {
    if (lxcCurrentStep() === 2) { lxcHist = false; go(1); }
  });
  var backTop = root.querySelector('#lxc-back-top');
  if (backTop) backTop.addEventListener('click', backToStyles);

  // ---- step 1: style grid ----
  var grid = root.querySelector('#lxc-grid');
  Object.keys(DATA).forEach(function (name) {
    var m = DATA[name]; m.name = name;
    // official per-finish galleries (real photos, 1:1) override the placeholder gallery
    if (FG[name]) {
      m.finishGalleries = FG[name];
      var _def = (m.finishes || []).filter(function (f) { return FG[name][f]; })[0] || Object.keys(FG[name])[0];
      var _g = FG[name][_def];
      if (_g && _g.length) { m.gallery = _g; m.img = _g[0]; }
    }
    // per-finish 3D models (generated + real) — 3D shows for every model/finish that has one
    if (GLBMAP[name]) {
      m.glbFinishes = Object.assign({}, m.glbFinishes || {}, GLBMAP[name]);
      if (!m.glb) m.glb = m.glbFinishes[(m.finishes || [])[0]] || m.glbFinishes[Object.keys(m.glbFinishes)[0]];
    }
    var lo = m.sizes.slice().sort(function (a, b) { return a.price - b.price; })[0].price;
    var b = document.createElement('div');
    b.className = 'lxc-card'; b.setAttribute('role', 'button'); b.tabIndex = 0; b.setAttribute('aria-pressed', 'false');
    b.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectModel(name, b); } });
    b.innerHTML = '<div class="lxc-card__imgwrap"><img alt="' + name + ' non-combustible mantel" loading="lazy"></div>' +
      '<div class="lxc-card__b"><strong>' + name + '</strong><span>' + m.depth + ' D &times; ' + m.height + ' H &middot; from ' + money(lo) + '</span>' +
      '<div class="lxc-card__sw" role="group" aria-label="Preview colors"></div></div>';
    var cimg = b.querySelector('img'); cimg.src = m.img;
    var sw = b.querySelector('.lxc-card__sw');
    m.finishes.forEach(function (f) {
      var dot = document.createElement('button'); dot.type = 'button'; dot.className = 'lxc-card__dot'; dot.title = f; dot.setAttribute('aria-label', f);
      if (SWATCH[f]) dot.style.backgroundImage = 'url(' + SWATCH[f] + ')'; else dot.classList.add('lxc-card__noimg');
      dot.addEventListener('click', function (e) {
        e.stopPropagation();
        var g = (m.finishGalleries && m.finishGalleries[f] && m.finishGalleries[f][0]) || SWATCH[f] || m.img;
        cimg.src = g; m._previewFinish = f;
        sw.querySelectorAll('.lxc-card__dot').forEach(function (d) { d.classList.remove('on'); }); dot.classList.add('on');
      });
      sw.appendChild(dot);
    });
    b.addEventListener('click', function () { selectModel(name, b); });
    grid.appendChild(b);
  });

  // Clickable step chips — jump back to any reached step
  root.querySelectorAll('.lxc__steps span').forEach(function (s) {
    s.setAttribute('role', 'button'); s.tabIndex = 0;
    var jump = function () { var n = +s.dataset.step; if (n === 1) return go(1); if (!state.model) return; go(n); };
    s.addEventListener('click', jump);
    s.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); jump(); } });
  });

  // Deep-link 2026-08-14: ?style=Flat+Sawn (z listingow standard) -> auto krok 2 z tym stylem
  try {
    var qsp = new URLSearchParams(location.search);
    var qsStyle = (qsp.get('style') || '').trim().toLowerCase();
    if (qsStyle) {
      var qsHit = Object.keys(DATA).find(function (k) { return k.toLowerCase() === qsStyle; });
      if (qsHit) setTimeout(function () {
        var qsCard = Array.prototype.find.call(grid.querySelectorAll('.lxc-card'), function (c) {
          var st = c.querySelector('strong'); return st && st.textContent.trim() === qsHit;
        });
        selectModel(qsHit, qsCard || null);
        var qsFin = (qsp.get('finish') || '').trim().toLowerCase();
        if (qsFin) {
          var fb = Array.prototype.find.call(root.querySelectorAll('#lxc-finish button span'), function (s) { return s.textContent.trim().toLowerCase() === qsFin; });
          if (fb) fb.closest('button').click();
        }
      }, 60);
    }
  } catch (e) {}

  function selectModel(name, btn) {
    state.model = DATA[name];
    state.finish = state.model._previewFinish || state.model.finishes[0];
    grid.querySelectorAll('.lxc-card').forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
    if (btn) btn.setAttribute('aria-pressed', 'true');
    buildStep2();
    go(2);
  }

  // ---- step 2: width ----
  function buildStep2() {
    var m = state.model;
    var sizes = m.sizes.slice().sort(function (a, b) { return a.w - b.w; });
    var minStd = m.minWidth || sizes[0].w, maxStd = sizes[sizes.length - 1].w, capMax = Math.min(120, maxStd + 48);
    state.width = maxStd; // default to largest standard

    root.querySelector('#lxc-m-name').textContent = m.name + ' Non-Combustible Mantel';
    root.querySelector('#lxc-m-depth').textContent = m.depth;
    root.querySelector('#lxc-m-height').textContent = m.height;
    var dEl = root.querySelector('#lxc-m-desc'); if (dEl) dEl.textContent = m.desc || '';
    // gallery (white-bg; swaps per finish if finish-specific images exist)
    renderGallery(galleryFor(m, state.finish));

    // standard quick-picks
    var std = root.querySelector('#lxc-std'); std.innerHTML = '';
    sizes.forEach(function (s) {
      var bt = document.createElement('button'); bt.type = 'button'; bt.textContent = s.w + '"';
      bt.dataset.w = s.w; bt.addEventListener('click', function () { setWidth(s.w); });
      std.appendChild(bt);
    });

    // finishes
    var fin = root.querySelector('#lxc-finish'); fin.innerHTML = '';
    m.finishes.forEach(function (f) {
      var bt = document.createElement('button'); bt.type = 'button';
      bt.innerHTML = (SWATCH[f] ? '<img src="' + SWATCH[f] + '" alt="" loading="lazy">' : '') + '<span>' + f + '</span>';
      bt.addEventListener('click', function () {
        state.finish = f; fin.querySelectorAll('button').forEach(function (x) { x.classList.remove('is-active'); }); bt.classList.add('is-active'); toggleColorRef(false); render2();
        renderGallery(galleryFor(m, f));
        showVisual(m, f, state.width);
        flashGalHint(f);
      });
      if (f === state.finish) bt.classList.add('is-active');
      fin.appendChild(bt);
    });
    // Custom Color Match (+$300) — match any color from a paint chip, sample or photo
    var cf = document.createElement('button'); cf.type = 'button'; cf.className = 'lxc-cf';
    cf.innerHTML = '<span class="lxc-rainbow" aria-hidden="true"></span> Custom Color Match <b>+$300</b>';
    cf.addEventListener('click', function () {
      state.finish = CF_LABEL; fin.querySelectorAll('button').forEach(function (x) { x.classList.remove('is-active'); }); cf.classList.add('is-active'); toggleColorRef(true); render2();
    });
    fin.appendChild(cf);
    toggleColorRef(false);

    var range = root.querySelector('#lxc-range');
    range.min = minStd; range.max = capMax; range.step = 0.5; range.value = maxStd;
    range.oninput = function () { setWidth(parseFloat(range.value)); };
    var num = root.querySelector('#lxc-num');
    num.min = minStd; num.max = capMax; num.step = 0.5; num.value = maxStd;
    num.onchange = function () { setWidth(parseFloat(num.value) || maxStd); };

    setWidth(maxStd);
  }

  function setWidth(w) {
    var c = calc(state.model, w);
    state.width = c.width;
    var rng = root.querySelector('#lxc-range');
    rng.value = c.width;
    // purely visual: expose the filled fraction so CSS can paint the track up to the thumb
    var rmn = parseFloat(rng.min), rmx = parseFloat(rng.max);
    if (rmx > rmn) rng.style.setProperty('--lxc-fill', (((c.width - rmn) / (rmx - rmn)) * 100).toFixed(1) + '%');
    root.querySelector('#lxc-num').value = c.width;
    root.querySelectorAll('#lxc-std button').forEach(function (b) { b.classList.toggle('is-active', +b.dataset.w === c.width); });
    render2();
    showVisual(state.model, state.finish, c.width);
  }

  function render2() {
    var c = calc(state.model, state.width);
    // combo banner
    var ban = root.querySelector('#lxc-banner');
    if (c.combo) {
      ban.classList.add('is-on');
      var bset = c.brackets + ' decorative metal bracket trim set' + (c.brackets > 1 ? 's' : '');
      var bhow = (c.brackets > c.ext) ? ' — one conceals the joint, the second mirrors it on the opposite side so the mantel stays symmetrical.' : ' that conceal the seams.';
      ban.innerHTML = '<b>Made in ' + c.pieces + ' joined pieces + ' + c.brackets + ' decorative bracket sets</b>' +
        'At ' + fmtW(c.width) + ', your mantel ships as ' + c.pieces + ' sections seamlessly joined on-site, finished with ' + bset + bhow + (state.model.comboNote ? ' ' + state.model.comboNote : '') +
        '<a class="lxc__combodiag" href="' + COMBO_DIAGRAM + '" target="_blank" rel="noopener"><img src="' + COMBO_DIAGRAM + '" alt="How combo mantels are built — extensions joined with decorative brackets (DBT)" loading="lazy"><span>How your ' + c.pieces + '-piece mantel is assembled · tap to enlarge</span></a>';
    } else if (c.custom) {
      ban.classList.add('is-on');
      ban.innerHTML = '<b>Custom width &mdash; cut &amp; finished to ' + fmtW(c.width) + '</b>Hand-trimmed from our ' + c.baseW + '" mantel to your exact opening (&plusmn;&frac12;"). +' + money(c.fee) + ' custom fee.';
    } else { ban.classList.remove('is-on'); ban.innerHTML = ''; }

    // price + breakdown
    var ff = (state.finish === CF_LABEL) ? CUSTOM_FINISH_FEE : 0;
    root.querySelector('#lxc-amt').textContent = money(c.price + ff);
    var bd = root.querySelector('#lxc-breakdown'); bd.innerHTML = '';
    var rows = [];
    if (c.combo) {
      rows.push(['Base ' + c.maxStd + '" mantel', money(c.base)]);
      rows.push([c.ext + ' &times; extension (65% each)', money(c.price - c.base)]);
      rows.push([c.brackets + ' &times; decorative bracket set', 'included']);
    } else if (c.custom) {
      rows.push(['Base ' + c.baseW + '" mantel', money(c.base)]);
      rows.push(['Custom width fee', '+' + money(c.fee)]);
    }
    if (ff) rows.push(['Custom color match', '+' + money(ff)]);
    rows.forEach(function (r) { bd.innerHTML += '<div><span>' + r[0] + '</span><span>' + r[1] + '</span></div>'; });
    updateBuy();
  }

  root.querySelector('#lxc-back1').addEventListener('click', backToStyles);

  // ---- step 2: buy actions — EVERYTHING adds to the cart (base variant + made-to-order surcharge) ----
  // base variant = real product variant at the relevant standard width (custom width cuts from baseW; combo from maxStd).
  // For Custom Color Match or finishes without their own variant, any finish's variant at that width is used and the
  // real finish/size/title are shown in cart via line-item properties (_title / Finish / Width / _swatch_url).
  function baseVariantFor(m, finish, c) {
    var map = VARIANTS[m.name]; if (!map) return null;
    var bw = String(c.combo ? c.maxStd : (c.custom ? c.baseW : c.width));
    if (finish !== CF_LABEL && map[finish] && map[finish][bw]) return { id: map[finish][bw], finishKey: finish };
    var fins = Object.keys(map);
    for (var i = 0; i < fins.length; i++) { if (map[fins[i]][bw]) return { id: map[fins[i]][bw], finishKey: fins[i] }; }
    return null;
  }
  function buyState() {
    var m = state.model, c = calc(m, state.width), ff = (state.finish === CF_LABEL) ? CUSTOM_FINISH_FEE : 0, total = c.price + ff;
    var isCustom = c.custom || c.combo || state.finish === CF_LABEL;
    var basePrice = (c.combo || c.custom) ? c.base : c.price;
    var base = baseVariantFor(m, state.finish, c);
    var surcharge = Math.max(0, Math.round(total - basePrice));
    return { c: c, ff: ff, total: total, isCustom: isCustom, base: base, basePrice: basePrice, surcharge: surcharge };
  }
  function updateBuy() {
    var buy = root.querySelector('#lxc-buy'); if (!buy || !state.model) return;
    var b = buyState(), add = root.querySelector('#lxc-add'), exp = root.querySelector('#lxc-express'),
        cn = root.querySelector('#lxc-custnote'), qty = root.querySelector('#lxc-qty');
    if (b.base) {
      buy.dataset.mode = 'native';
      add.innerHTML = 'Add to Cart &mdash; ' + money(b.total);
      exp.style.display = ''; if (cn) cn.style.display = 'none';
      // made-to-order custom items are 1-off — hide qty (keeps the base+surcharge math clean)
      if (qty) qty.style.display = b.isCustom ? 'none' : '';
      if (b.isCustom) { var qn = root.querySelector('#lxc-qnum'); if (qn) qn.value = 1; }
    } else {
      buy.dataset.mode = 'worker';
      add.innerHTML = 'Buy Now &mdash; ' + money(b.total);
      exp.style.display = 'none'; if (cn) cn.style.display = ''; if (qty) qty.style.display = 'none';
    }
  }
  function lxcQty() { return Math.max(1, parseInt((root.querySelector('#lxc-qnum') || {}).value, 10) || 1); }
  function lxcErr(msg) { var e = root.querySelector('#lxc-err'); if (!e) return; if (msg) { e.textContent = msg; e.style.display = 'block'; } else { e.style.display = 'none'; } }
  function buildProps(c, ff) {
    var m = state.model, p = {
      'Model': m.name + ' Non-Combustible Mantel',
      'Finish': ff ? (CF_LABEL + ' (+$300)') : state.finish,
      'Width': fmtW(c.width), 'Depth': m.depth, 'Height': m.height,
      'Construction': c.pieces === 1 ? 'Single piece' : (c.pieces + '-piece joined + ' + c.brackets + ' decorative bracket sets')
    };
    var cref = ((root.querySelector('#lxc-colorref') || {}).value || '').trim();
    if (ff && cref) p['Color reference'] = cref;
    var note = ((root.querySelector('#lxc-notes') || {}).value || '').trim();
    if (note) p['Notes'] = note;
    return p;
  }
  // native add-to-cart — base variant (real price) + made-to-order surcharge ($1 × $diff), grouped in cart
  function addNative(goCheckout) {
    var b = buyState(); if (!b.base) return workerCheckout();
    /* 2026-08-13 (Daniel: "kosmiczne ilosci sztuk"): kazda DOPLATA idzie przez Draft Order
       Worker (1 linia, prawdziwa cena, qty 1) zamiast do koszyka jako $1 x kwota. */
    if (b.surcharge > 0) return workerCheckout();
    var m = state.model, c = b.c, qn = b.isCustom ? 1 : lxcQty();
    var btn = goCheckout ? root.querySelector('#lxc-express') : root.querySelector('#lxc-add'), label = btn.innerHTML;
    btn.disabled = true; btn.textContent = goCheckout ? 'Going to checkout…' : 'Adding…'; lxcErr(null);
    var cfg = 'lxc-' + Date.now();
    var bp = buildProps(c, b.ff);
    bp['_title'] = m.name + ' Non-Combustible Mantel';
    bp['_config_id'] = cfg; bp['_lxc'] = '1';
    if (state.finish !== CF_LABEL && SWATCH[state.finish]) bp['_swatch_url'] = SWATCH[state.finish];
    var items = [{ id: Number(b.base.id), quantity: qn, properties: bp }];
    if (b.surcharge > 0) {
      var parentTitle = (PTITLES[m.name] && PTITLES[m.name][b.base.finishKey]) || '';
      var optType = c.combo ? ('Made-to-order — ' + c.pieces + '-piece, ' + fmtW(c.width))
                  : c.custom ? ('Made-to-order — custom ' + fmtW(c.width))
                  : 'Custom color match';
      items.push({ id: SURCHARGE_VARIANT, quantity: b.surcharge, properties: {
        '_parent_product': parentTitle, '_config_id': cfg, '_option_type': optType, '_amount_only': '1', '_lxc': '1'
      } });
    }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) return r.json().then(function (d) { throw new Error((d && d.description) || ('cart ' + r.status)); }); return r.json(); })
      .then(function () {
        if (goCheckout) { (window.top || window).location.href = '/checkout'; return; }
        btn.disabled = false; btn.innerHTML = label;
        if (window.EFCartDrawer && window.EFCartDrawer.open) window.EFCartDrawer.open();
        else window.location.href = '/cart';
      })
      .catch(function () { btn.disabled = false; btn.innerHTML = label; lxcErr('Could not add to cart. Please try again or call (949) 619-7824.'); });
  }
  // worker checkout (custom price) — custom width / combo / Custom Color Match
  function workerCheckout() {
    var btn = root.querySelector('#lxc-add'), label = btn.innerHTML;
    var m = state.model, c = calc(m, state.width), ff = (state.finish === CF_LABEL) ? CUSTOM_FINISH_FEE : 0, total = c.price + ff;
    lxcErr(null); btn.disabled = true; btn.textContent = 'Creating your order…';
    var P = buildProps(c, ff); P['_config_id'] = 'lxc-' + Date.now();
    var note = ((root.querySelector('#lxc-notes') || {}).value || '').trim();
    var payload = {
      product_title: 'Custom ' + m.name + ' Mantel — ' + fmtW(c.width) + ' ' + state.finish,
      variant_id: m.variantId, quantity: lxcQty(), calculated_price: Math.round(total * 100), properties: P,
      customer_note: 'Lexington custom mantel — ' + Object.keys(P).map(function (k) { return k + ': ' + P[k]; }).join(' | ') + (note ? (' || Notes: ' + note) : '')
    };
    var inIframe = (window.top !== window.self);
    function doSend() {
      fetch(WORKER, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, status: r.status, d: d }; }); })
        .then(function (res) {
          if (res.ok && res.d && res.d.invoice_url) {
            if (inIframe) { window.open(res.d.invoice_url, '_blank'); btn.disabled = false; btn.innerHTML = label; }
            else { window.location.href = res.d.invoice_url; }
            return;
          }
          throw new Error('Worker ' + res.status);
        })
        .catch(function () { btn.disabled = false; btn.innerHTML = label; lxcErr('Could not create your order. Please call (949) 619-7824 or try again.'); });
    }
    var photoInput = root.querySelector('#lxc-photo');
    var file = (ff && photoInput && photoInput.files && photoInput.files[0]) ? photoInput.files[0] : null;
    if (file && file.size <= 10 * 1024 * 1024) {
      var reader = new FileReader();
      reader.onload = function () { payload.color_photo = reader.result; payload.color_photo_name = file.name; doSend(); };
      reader.onerror = function () { doSend(); };
      reader.readAsDataURL(file);
    } else { doSend(); }
  }
  root.querySelector('#lxc-add').addEventListener('click', function () {
    if (root.querySelector('#lxc-buy').dataset.mode === 'native') addNative(false); else workerCheckout();
  });
  root.querySelector('#lxc-express').addEventListener('click', function () { addNative(true); });
  (function () {
    var minus = root.querySelector('#lxc-qminus'), plus = root.querySelector('#lxc-qplus'), n = root.querySelector('#lxc-qnum');
    function set(v) { if (n) n.value = Math.max(1, v); }
    if (minus) minus.addEventListener('click', function () { set(lxcQty() - 1); });
    if (plus) plus.addEventListener('click', function () { set(lxcQty() + 1); });
  })();

  // upload label feedback
  (function () {
    var pi = root.querySelector('#lxc-photo'), tx = root.querySelector('#lxc-upload-text');
    if (pi && tx) pi.addEventListener('change', function () {
      tx.textContent = (pi.files && pi.files[0]) ? ('✓ ' + pi.files[0].name + ' attached') : '📎 Upload a photo of your color';
    });
  })();

  // scrollbar width -> --ef-sbw so the full-bleed bands don't trigger horizontal scroll
  (function () {
    function setSbw() {
      var sbw = window.innerWidth - document.documentElement.clientWidth;
      document.documentElement.style.setProperty('--ef-sbw', (sbw > 0 ? sbw : 0) + 'px');
    }
    setSbw();
    window.addEventListener('resize', setSbw, { passive: true });
  })();

  // scroll-reveal + animated counters for the premium info section
  (function () {
    function animateCounts(scope) {
      var nodes = scope.querySelectorAll('[data-count]');
      for (var i = 0; i < nodes.length; i++) {
        (function (el) {
          if (el._counted) return; el._counted = true;
          var to = parseFloat(el.getAttribute('data-count')) || 0;
          var suf = el.getAttribute('data-suffix') || '';
          var dur = 1200, start = null;
          function step(ts) {
            if (start === null) start = ts;
            var p = Math.min(1, (ts - start) / dur);
            var eased = 1 - Math.pow(1 - p, 3); // ease-out cubic
            el.textContent = Math.round(to * eased) + suf;
            if (p < 1) requestAnimationFrame(step);
          }
          requestAnimationFrame(step);
        })(nodes[i]);
      }
    }
    var els = document.querySelectorAll('.lxc-reveal');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); animateCounts(el); });
      return;
    }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); animateCounts(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  })();

  // install-video facade -> load YouTube on click
  (function () {
    var vf = document.getElementById('lxc-vfacade'); if (!vf) return;
    vf.addEventListener('click', function () {
      var id = vf.getAttribute('data-yt');
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0';
      f.title = 'Mantel installation video';
      f.setAttribute('allow', 'autoplay; encrypted-media; fullscreen; picture-in-picture');
      f.setAttribute('allowfullscreen', '');
      f.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;border:0;';
      vf.parentNode.replaceChild(f, vf);
    });
  })();
})();

/* ===== EF UX layer — 2026-08-07 (agent) =====================================
   Adds on top of the configurator WITHOUT touching its logic/handlers:
   1) crossfade (~250ms) of the main gallery image when a finish (or thumb) swaps it
      + capture-phase preload of the finish's first photo before the swap paints
   2) "Save my design" -> localStorage 'ef-saved-projects' ({title,url,date},
      format read by /pages/saved · sections/efn-saved.liquid) + toast
   3) "Most ordered" badge on the best-selling finish (data-bestseller-finish,
      source: collection concrete-mantel-shelves BEST_SELLING, 2026-08-07)
   ========================================================================== */
(function () {
  'use strict';
  var root = document.getElementById('lxc-root');
  if (!root) return;
  var FG2 = {}; try { FG2 = JSON.parse(document.getElementById('ef-lxc-fg').textContent); } catch (e) {}

  function modelName() {
    var el = root.querySelector('#lxc-m-name');
    return el ? el.textContent.replace(/\s*Non-Combustible Mantel\s*$/, '').trim() : '';
  }

  /* ---- 1) crossfade on the main gallery image ---- */
  var mainImg = root.querySelector('#lxc-m-img');
  if (mainImg && 'MutationObserver' in window) {
    var crossfade = function (oldSrc) {
      try {
        var wrap = mainImg.parentNode;
        if (getComputedStyle(wrap).position === 'static') wrap.style.position = 'relative';
        var prev = wrap.querySelector('.lxc-imgfade');
        if (prev && prev.parentNode) prev.parentNode.removeChild(prev);
        var ov = document.createElement('img');
        ov.className = 'lxc-imgfade'; ov.alt = ''; ov.setAttribute('aria-hidden', 'true');
        ov.src = oldSrc;
        ov.style.top = mainImg.offsetTop + 'px'; ov.style.left = mainImg.offsetLeft + 'px';
        ov.style.width = mainImg.offsetWidth + 'px'; ov.style.height = mainImg.offsetHeight + 'px';
        wrap.insertBefore(ov, mainImg.nextSibling);
        var done = false;
        var fadeOut = function () {
          if (done) return; done = true;
          requestAnimationFrame(function () { ov.style.opacity = '0'; });
          setTimeout(function () { if (ov.parentNode) ov.parentNode.removeChild(ov); }, 420);
        };
        if (mainImg.complete && mainImg.naturalWidth > 0) fadeOut();
        else { mainImg.addEventListener('load', fadeOut, { once: true }); setTimeout(fadeOut, 1500); }
      } catch (e) { /* fade is decorative — never break the page */ }
    };
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var oldSrc = muts[i].oldValue, cur = mainImg.getAttribute('src');
        if (oldSrc && cur && oldSrc !== cur) { crossfade(oldSrc); break; }
      }
    }).observe(mainImg, { attributes: true, attributeFilter: ['src'], attributeOldValue: true });
  }
  // preload the finish's first photo before the configurator swaps the gallery
  root.addEventListener('pointerdown', function (e) {
    var t = e.target && e.target.closest ? e.target : null; if (!t) return;
    var fin = null, model = null;
    var chip = t.closest('#lxc-finish button');
    if (chip && !chip.classList.contains('lxc-cf')) {
      var sp = chip.querySelector('span'); fin = sp ? sp.textContent.trim() : null; model = modelName();
    } else {
      var dot = t.closest('.lxc-card__dot');
      if (dot) {
        fin = dot.getAttribute('aria-label') || dot.title;
        var card = dot.closest('.lxc-card'), st = card && card.querySelector('strong');
        model = st ? st.textContent.trim() : null;
      }
    }
    if (fin && model && FG2[model] && FG2[model][fin] && FG2[model][fin][0]) {
      var im = new Image(); im.src = FG2[model][fin][0];
    }
  }, true);

  /* ---- 2) Save my design ---- */
  var saveBtn = root.querySelector('#lxc-save'), toast = document.getElementById('lxc-toast'), toastTimer = null;
  function showToast() {
    if (!toast) return;
    toast.hidden = false;
    requestAnimationFrame(function () { requestAnimationFrame(function () { toast.classList.add('is-on'); }); });
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('is-on'); }, 5000);
  }
  if (saveBtn) saveBtn.addEventListener('click', function () {
    try {
      var finBtn = root.querySelector('#lxc-finish button.is-active');
      var finish = finBtn ? (finBtn.classList.contains('lxc-cf') ? 'Custom Color Match' : (finBtn.querySelector('span') ? finBtn.querySelector('span').textContent.trim() : '')) : '';
      var width = (root.querySelector('#lxc-num') || {}).value || '';
      var title = 'Custom Concrete Mantel — ' + (finish || 'your finish') + ' · ' + width + '"';
      // no URL serialization of the configuration exists in this configurator -> save the page URL
      var entry = { title: title, url: window.location.href, date: new Date().toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) };
      var arr = [];
      try { arr = JSON.parse(localStorage.getItem('ef-saved-projects') || '[]'); } catch (e) { arr = []; }
      if (!Array.isArray(arr)) arr = [];
      arr = arr.filter(function (p) { return !(p && p.title === entry.title && p.url === entry.url); });
      arr.unshift(entry);
      if (arr.length > 50) arr.length = 50;
      localStorage.setItem('ef-saved-projects', JSON.stringify(arr));
      saveBtn.classList.add('is-saved');
      var lbl = saveBtn.querySelector('span'); if (lbl) lbl.textContent = 'Saved to your projects';
      setTimeout(function () { saveBtn.classList.remove('is-saved'); if (lbl) lbl.textContent = 'Save my design'; }, 4000);
      showToast();
    } catch (e) { /* storage blocked (private mode) — fail silently */ }
  });

  /* ---- 3) "Most ordered" badge on the best-selling finish ---- */
  var BEST = root.getAttribute('data-bestseller-finish');
  var finWrap = root.querySelector('#lxc-finish');
  function decorate() {
    if (!BEST || !finWrap) return;
    var btns = finWrap.querySelectorAll('button');
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i];
      if (b.classList.contains('lxc-cf') || b.querySelector('.lxc-mostordered')) continue;
      var sp = b.querySelector('span');
      if (sp && sp.textContent.trim() === BEST) {
        var badge = document.createElement('span');
        badge.className = 'lxc-mostordered'; badge.textContent = 'Most ordered';
        b.appendChild(badge);
      }
    }
  }
  if (finWrap && 'MutationObserver' in window) {
    new MutationObserver(function () { decorate(); }).observe(finWrap, { childList: true });
  }
  decorate();
})();

/* 2026-08-07 (agent): the width-to-scale "8-ft wall" SVG illustration was removed
   (markup #lxc-scalewall + its CSS + this redraw block). It read as a diagram, not
   as premium product imagery — the live 3D model now carries the scale story. */
